webpackJsonp([208863975630277],{

/***/ 341:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":3,"edges":[{"node":{"frontmatter":{"title":"New Beginnings","date":"2015-05-28T22:40:32.169Z","path":"/taurus-second/"},"excerpt":"Far far away, behind the word mountains, far from the countries Vokalia\nand Consonantia, there live the blind texts. Separated they live in…","timeToRead":4}},{"node":{"frontmatter":{"title":"My Second Post!","date":"2015-05-06T23:46:37.121Z","path":"/taurus-third/"},"excerpt":"Wow! I love blogging so much already. Did you know that \"despite its name, salted duck eggs can also be made from chicken eggs, though the…","timeToRead":1}},{"node":{"frontmatter":{"title":"Hello World","date":"2015-05-01T22:12:03.284Z","path":"/taurus-first/"},"excerpt":"This is my first post on my new fake blog! How exciting! I'm sure I'll write a lot more interesting things in the future. Oh, and here's a…","timeToRead":1}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---news-92c742c16f3c1369b311.js